import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ebw-monorepo-as-footer',
  templateUrl: './as-footer.component.html',
  styleUrls: ['./as-footer.component.scss']
})
export class AsFooterComponent {

  private _buttons: {label: string, type: 'outline' | 'flat'}[];
  private _styleWrapper: string;
  private _styleLabel: string;
  private _styleContainer: string;
  private _infoLabel: string;
  tempArray: {label: string, type: 'outline' | 'flat'}[];

  @Output() changeComponentHandler: EventEmitter<string> = new EventEmitter<string>();

  get infoLabel(): string {
    return this._infoLabel;
  }

  @Input() set infoLabel(infoLabel: string) {
    this._infoLabel = infoLabel;
  }

  get buttons(): {label: string, type: 'outline' | 'flat'}[] {
    return this._buttons;
  }

  @Input() set buttons(buttons: {label: string, type: 'outline' | 'flat'}[]) {
    this._buttons = buttons;
    this.tempArray = [...this._buttons];
  }

  get styleWrapper(): string {
    return this._styleWrapper;
  }

  @Input() set styleWrapper(styleWrapper: string) {
     this._styleWrapper = styleWrapper;
  }

  get styleLabel(): string {
    return this._styleLabel;
  }

  @Input() set styleLabel(styleLabel: string) {
     this._styleLabel = styleLabel;
  }

  get styleContainer(): string {
    return this._styleContainer;
  }

  @Input() set styleContainer(styleContainer: string) {
     this._styleContainer = styleContainer;
  }

  changeComponent(btn: string) {
    this.tempArray = [...this._buttons];
    this.changeComponentHandler.emit(btn);
  }

}
